import type { ProfileState } from "../../types/profile";
import { SET_CURRENT_PROFILE, 
  SET_FORGOT_PASSWORD_CONFIRMATION_STATUS, 
  SET_LOGIN_REDIRECT, 
  SET_EMAIL_ADDRESS, 
  SET_RESET_PASSWORD_BOOLEAN, 
  SET_PROFILE_DETAILS, 
  SET_FORGOT_PASSWORD_ERROR_MESSAGE,
  SET_EDIT_PROFILE_ERROR_MESSAGE,
  SET_EDIT_PROFILE_SUCCESS_MESSAGE,
  SET_LOGIN_REDIRECT_FROM_RESET_PASSWORD,
  SET_IS_GET_PROFILE_PENDING,
  SET_IS_EDIT_PROFILE_PENDING,
 } from "../constants/profile.constants";

const initialState: ProfileState = {
  userName: "",
  email: "",
  currentUserRoles: [],
  currentProfileRole: null,
  confirmationStatus: "",
  softwareVersion: "1.3.2",
  isLoginRedirect: false,
  isLoginRedirectFromResetpassword: false,
  isResetPassword: false,
  profileDetails: null,
  forgorPasswordErrorMessage:"",
  editProfileSuccessMessage:"",
  editProfileErrorMessage:"",
  isGetProfilePending: false,
  isEditProfilePending: false,
};

export default (
  localState: ProfileState = initialState,
  action: Action
): ProfileState => {
  switch (action.type) {
    case SET_CURRENT_PROFILE: {
      const { userName, email, roles, userId, currentRole, geoLocation } = action.payload;
      return {
        ...localState,
        userName,
        email,
        userId,
        currentUserRoles: roles,
        currentProfileRole: currentRole,
        geoLocation: geoLocation,
      };
    }
    case SET_FORGOT_PASSWORD_CONFIRMATION_STATUS: {
      return {
        ...localState,
        confirmationStatus: action.payload
      }
    }
    case SET_LOGIN_REDIRECT: {
      return {
        ...localState,
        isLoginRedirect: action.payload
      }
    }
    case SET_EMAIL_ADDRESS: {
      return {
        ...localState,
        emailAddress: action.payload
      }
    }
    case SET_RESET_PASSWORD_BOOLEAN: {
      return {
        ...localState,
        isResetPassword: action.payload
      }
    }
    case SET_PROFILE_DETAILS: {
      return {
        ...localState,
        profileDetails: action.payload
      }
    }
    case SET_FORGOT_PASSWORD_ERROR_MESSAGE: {
      return {
        ...localState,
        forgorPasswordErrorMessage: action.payload
      }
    }
    case SET_EDIT_PROFILE_SUCCESS_MESSAGE: {
      return{
        ...localState,
        editProfileSuccessMessage: action.payload
      }
    }
    case SET_EDIT_PROFILE_ERROR_MESSAGE: {
      return{
        ...localState,
        editProfileErrorMessage: action.payload
      }
    }
    case SET_LOGIN_REDIRECT_FROM_RESET_PASSWORD: {
      return{
        ...localState,
        isLoginRedirectFromResetPassword: action.payload
      }
    }
    case SET_IS_GET_PROFILE_PENDING: {
      return {
        ...localState,
        isGetProfilePending: action.payload
      }
    }
    case SET_IS_EDIT_PROFILE_PENDING: {
      return {
        ...localState,
        isEditProfilePending: action.payload
      }
    }
    default: {
      return localState;
    }
  }
};
